import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-00526844"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col p-2 space-y-6 text-gray-200" }
const _hoisted_2 = { class: "flex flex-wrap gap-3" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-center justify-between bg-[#1b1f2a] p-5 rounded-xl border border-transparent shadow-sm" }
const _hoisted_5 = { class: "flex flex-col w-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "text-sm text-gray-400 mb-1" }, "Template disponible", -1))
const _hoisted_7 = ["value"]
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_10 = { class: "flex flex-col lg:flex-row gap-6" }
const _hoisted_11 = { class: "lg:w-1/2 bg-[#1b1f2a] p-6 rounded-xl border border-transparent shadow-sm" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Configuration du Template", -1))
const _hoisted_13 = { class: "block text-sm text-gray-400 mb-1" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "flex justify-between mt-6" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "lg:w-1/2 bg-[#12161d] p-6 rounded-xl border border-transparent shadow-sm" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-semibold mb-4" }, "Aperçu PDF", -1))
const _hoisted_21 = {
  key: 0,
  class: "w-full h-[80vh] rounded overflow-hidden border border-gray-700"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "text-gray-500 italic text-sm"
}

import { ref, computed, onMounted } from "vue";
import { useTemplateApi } from "@/api/templates";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { TemplateRegistry } from "@/components/templates";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateBuilder',
  setup(__props) {

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const api = useTemplateApi();

const documentTypes = [
  { key: "ticket", label: "Tickets de Voyage" },
  { key: "baggage-ticket", label: "Tickets Bagages" },
  { key: "docket-travel", label: "Bordereaux de Voyage" },
  { key: "docket-shipping", label: "Bordereaux d’Expédition" },
  { key: "invoice", label: "Factures" },
  { key: "others", label: "Autres" },
];

const activeType = ref("ticket");
const selectedTemplateRef = ref("");
const formValues = ref<Record<string, any>>({});
const pdfUrl = ref<string | null>(null);
const loading = ref(false);

// 🔍 Filtrage dynamique
const filteredTemplates = computed(() =>
  TemplateRegistry.filter(t => t.type === activeType.value)
);

// Template courant
const currentTemplate = computed(() =>
  TemplateRegistry.find(t => t.reference === selectedTemplateRef.value)!
);

// Affiche le bouton si le template sélectionné n’est pas le défaut
const showSetDefaultButton = computed(() =>
  currentTemplate.value && !currentTemplate.value.is_default
);

const loadExistingParams = async () => {
  if (!currentTemplate.value) return;
  const resp:any = {} //await api.getParameters(currentTemplate.value.id);
  formValues.value = {
    ...Object.fromEntries(currentTemplate.value.variables.map(v => [v.key, v.default])),
    ...(resp.data || {}),
  };
};

const onTemplateChange = async () => {
  await loadExistingParams();
  pdfUrl.value = null;
};

const saveConfig = async () => {
  loading.value = true;
  try {
    await api.saveParameters(currentTemplate.value.id, formValues.value);
    await refreshPreview();
  } finally {
    loading.value = false;
  }
};

const refreshPreview = async () => {
  const resp = await api.getPreview(currentTemplate.value.id, formValues.value);
  const content = resp.data.content;
  const pdfDoc = pdfMake.createPdf(content);
  pdfDoc.getBlob(blob => (pdfUrl.value = URL.createObjectURL(blob)));
};

// Définir comme template par défaut
const setAsDefault = async () => {
  await api.selectTemplate(1, currentTemplate.value.id); // 1 = station courante (à remplacer dynamiquement)
  TemplateRegistry.forEach(t => {
    if (t.type === activeType.value) t.is_default = false;
  });
  currentTemplate.value.is_default = true;
};

onMounted(() => {
  const defaults = TemplateRegistry.find(t => t.is_default);
  if (defaults) {
    activeType.value = defaults.type;
    selectedTemplateRef.value = defaults.reference;
  } else {
    activeType.value = "ticket";
    selectedTemplateRef.value = filteredTemplates.value[0]?.reference;
  }
  loadExistingParams();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(documentTypes, (t) => {
        return _createElementVNode("button", {
          key: t.key,
          onClick: ($event: any) => (activeType.value = t.key),
          class: _normalizeClass(["px-4 py-2 rounded-md text-sm font-medium transition-all", activeType.value === t.key
          ? 'bg-green-600 text-white shadow'
          : 'bg-gray-800 hover:bg-gray-700 text-gray-300'])
        }, _toDisplayString(t.label), 11, _hoisted_3)
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTemplateRef).value = $event)),
          onChange: onTemplateChange,
          class: "w-full px-3 py-2 rounded bg-gray-800 border border-gray-600 text-sm focus:border-green-500 focus:ring-1 focus:ring-green-500"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredTemplates.value, (t) => {
            return (_openBlock(), _createElementBlock("option", {
              key: t.reference,
              value: t.reference
            }, [
              _createTextVNode(_toDisplayString(t.name) + " ", 1),
              (t.is_default)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " (par défaut)"))
                : _createCommentVNode("", true)
            ], 8, _hoisted_7))
          }), 128))
        ], 544), [
          [_vModelSelect, selectedTemplateRef.value]
        ])
      ]),
      (showSetDefaultButton.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: setAsDefault,
              class: "bg-green-600 hover:bg-green-700 px-4 py-2 rounded text-white text-sm font-medium"
            }, " Définir comme modèle par défaut ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentTemplate.value?.variables, (variable, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "mb-4"
          }, [
            _createElementVNode("label", _hoisted_13, _toDisplayString(variable.label), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((formValues.value[variable.key]) = $event),
              type: "text",
              class: "w-full px-3 py-2 rounded bg-gray-800 border border-gray-600 focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 text-sm"
            }, null, 8, _hoisted_14), [
              [_vModelText, formValues.value[variable.key]]
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            onClick: saveConfig,
            class: "bg-secondary hover:opacity-90 px-4 py-2 rounded text-white font-medium",
            disabled: loading.value
          }, [
            (loading.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "💾 Sauvegarde..."))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, "💾 Sauvegarder"))
          ], 8, _hoisted_16),
          _createElementVNode("button", {
            onClick: refreshPreview,
            class: "bg-gray-700 hover:bg-gray-600 px-4 py-2 rounded text-white font-medium"
          }, " 🔄 Mettre à jour la Preview ")
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        (pdfUrl.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("iframe", {
                src: pdfUrl.value,
                class: "w-full h-full bg-white"
              }, null, 8, _hoisted_22)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, " ⚙️ Aucun aperçu disponible. Cliquez sur \"Mettre à jour la Preview\". "))
      ])
    ])
  ]))
}
}

})